import React from 'react';
import ComplaintsBoard from './ComplaintBoard';

const InProgressComplaints = () => (
    <ComplaintsBoard
        statusFilter="inprogress"
        title="In Review Complaints"
        subtitle="Complaints currently being investigated"
    />
);

export default InProgressComplaints;